module.exports = __webpack_public_path__ + "3779950cc681324aab2cb270cf0b5577.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/hans-peter_kohler.png
// module id = 125
// module chunks = 0